if (!customElements.get('ig-families')) {
  customElements.define(
    'ig-families',
    class IgFamilies extends HTMLElement {
      connectedCallback() {
        this.panels = Array.from(this.querySelectorAll('[data-family-panel]'));
        if (this.panels.length < 2) return;

        this.index = this.panels.findIndex((panel) => !panel.classList.contains('hidden'));
        if (this.index < 0) this.index = 0;

        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-family-nav]');
          if (!button || !this.contains(button)) return;
          this.go(button.dataset.familyNav === 'prev' ? -1 : 1);
        });
      }

      go(delta) {
        const total = this.panels.length;
        this.index = (this.index + delta + total) % total;

        this.panels.forEach((panel, i) => {
          panel.classList.toggle('hidden', i !== this.index);
        });

        // Move focus to the matching arrow in the panel that just appeared, so
        // clicking through families with the keyboard does not lose the caret.
        const active = this.panels[this.index];
        const next = active.querySelector(`[data-family-nav="${delta < 0 ? 'prev' : 'next'}"]`);
        if (next && document.activeElement && this.contains(document.activeElement)) next.focus();
      }
    }
  );
}
